import { Formik } from "formik";
import { useUsers } from "../applicationsettings/hooks/useUsers";
import { Loader } from "../common/progress/Loader";
import { InviteUserForm } from "./InviteUserForm";
import { userGrantValidationSchema } from "./schemas/UserGrantValidationSchema";
import { UsersTable } from "./UsersTable";
import { useLocalization } from "../../contexts/LocalizationContext";
import { UserProfileRoleUpdate } from "./models/UserProfileRoleUpdate";

export const Users = () => {
  const { data, editModeId, isLoading, setEditModeId, handleLeave, getUsers, handleSubmit } = useUsers();
  const { translate } = useLocalization();

  if (isLoading) return <Loader />;

  const editableItem = data?.userProfiles.find((item) => item.id === editModeId);
  const initialValues: UserProfileRoleUpdate = { selectedRoleId: editableItem?.selectedRole.id ?? "" };

  return (
    <Formik<UserProfileRoleUpdate>
      initialValues={initialValues}
      validationSchema={userGrantValidationSchema(translate)}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      <>
        <hr className="d-block d-xl-none" aria-hidden />
        <h3 className="mb-3">{translate("settings.assignedUsers")}</h3>
        <UsersTable
          editModeId={editModeId}
          roles={data?.userRoles ?? []}
          users={data?.userProfiles ?? []}
          onDismiss={handleLeave}
          onDiscard={() => setEditModeId("")}
          onEdit={(id: string) => setEditModeId(id)}
        />
        <InviteUserForm roles={data?.userRoles ?? []} getUsers={getUsers} />
      </>
    </Formik>
  );
};
